import React, { useState, useRef, useEffect } from "react";

const HighSpeedString = ({ getString, field, value }) => {
    const [qrCodeResult, setQrCodeResult] = useState(value);

    const lastInputTimeRef = useRef(0);
    const ref = useRef()
    useEffect(() => {
        if (ref && ref.current) {
            ref.current.focus()
        }
    }, [])
    // lastInputTimeRef.current = new Date().getTime();
    // const inputRef = useRef()
    useEffect(() => {
        if (getString) {
            getString(qrCodeResult)
        }
    }, [qrCodeResult])

    useEffect(() => {
        if (value) {
            setQrCodeResult(value)
        }
    }, [value])


    const handleInput = (event) => {
        const currentTime = new Date().getTime();
        const timeDiff = currentTime - lastInputTimeRef.current;

        if (!qrCodeResult) {
            event.preventDefault()
            lastInputTimeRef.current = new Date().getTime();
            setQrCodeResult(event.target.value);
        } else if (timeDiff < 50) {
            lastInputTimeRef.current = new Date().getTime();
            setQrCodeResult(event.target.value);
        } else {
        }
    };



    return (
        <div className='col-sm-8 mt-4'>
            <div className="row">
                <div className="col pr-0">
                    <div className="form-group ">
                        <label className='small d-flex mb-0'>{field.FieldName}{field.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
                        <input
                            // ref={inputRef}
                            ref={ref}  // Store ref

                            className='form-control form-control-sm'
                            type="text"
                            value={qrCodeResult ? qrCodeResult : ""}
                            onInput={handleInput} // Detect rapid input for QR code
                            // onKeyDown={handleKeyDown} // Prevent manual typing
                            placeholder={field.FieldName + " here..."}
                        />
                    </div>
                </div>
                <div className="col mt-4 pl-0">
                    <button onClick={() => setQrCodeResult("")} className="btn btn-sm btn-danger">Clear</button>
                </div>
            </div>

        </div>
    );
};

export default HighSpeedString;
